import request from "@/libs/request";
import {
  CreateProjectGroupsScenariosRequest,
  CreateProjectGroupsScenariosResponse,
  DeleteProjectGroupsScenariosByIdResponse,
  ReadProjectGroupsScenariosByIdResponse,
  ReadProjectGroupsScenariosResponse,
  UpdateProjectGroupsScenariosByIdRequest,
  UpdateProjectGroupsScenariosByIdResponse,
} from "@/types/scenario";

// 시나리오 분석 생성
export const createProjectGroupsScenarios = async ({
  group_id,
  data,
}: {
  group_id: string;
  data: CreateProjectGroupsScenariosRequest;
}): Promise<CreateProjectGroupsScenariosResponse> => {
  const response = await request.post<CreateProjectGroupsScenariosResponse>(
    `/project-groups/${group_id}/scenarios/create`,
    data
  );
  return response.data;
};

// 시나리오 분석 목록 조회
export const readProjectGroupsScenarios = async ({
  group_id,
}: {
  group_id: string;
}): Promise<ReadProjectGroupsScenariosResponse> => {
  const response = await request.post<ReadProjectGroupsScenariosResponse>(
    `/project-groups/${group_id}/scenarios/read`
  );
  return response.data;
};

// 시나리오 분석 상세 조회
export const readProjectGroupsScenariosById = async ({
  group_id,
  scenario_id,
}: {
  group_id: string;
  scenario_id: string;
}): Promise<ReadProjectGroupsScenariosByIdResponse> => {
  const response = await request.post<ReadProjectGroupsScenariosByIdResponse>(
    `/project-groups/${group_id}/scenarios/${scenario_id}/read`
  );
  return response.data;
};

// 시나리오 분석 수정
export const updateProjectGroupsScenariosById = async ({
  group_id,
  scenario_id,
  data,
}: {
  group_id: string;
  scenario_id: string;
  data: UpdateProjectGroupsScenariosByIdRequest;
}): Promise<UpdateProjectGroupsScenariosByIdResponse> => {
  const response = await request.post<UpdateProjectGroupsScenariosByIdResponse>(
    `/project-groups/${group_id}/scenarios/${scenario_id}/update`,
    data
  );
  return response.data;
};

// 시나리오 분석 삭제
export const deleteProjectGroupsScenariosById = async ({
  group_id,
  scenario_id,
}: {
  group_id: string;
  scenario_id: string;
}): Promise<DeleteProjectGroupsScenariosByIdResponse> => {
  const response = await request.post<DeleteProjectGroupsScenariosByIdResponse>(
    `/project-groups/${group_id}/scenarios/${scenario_id}/delete`
  );
  return response.data;
};
